import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=307823bd&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"
import style0 from "./MainLayout.vue?vue&type=style&index=0&id=307823bd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307823bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('307823bd')) {
      api.createRecord('307823bd', component.options)
    } else {
      api.reload('307823bd', component.options)
    }
    module.hot.accept("./MainLayout.vue?vue&type=template&id=307823bd&scoped=true", function () {
      api.rerender('307823bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/MainLayout.vue"
export default component.exports